<template>
    <v-hover>
        <v-card flat hover slot-scope="{ hover }">
            <v-card-text>
                <div class="display-1">{{ (value.label)? value.label : d.label }}</div>
                <v-radio-group column v-model="valor">
                    <template v-for="o in value.opciones">
                        <v-radio :label="o" :value="o"></v-radio>
                    </template>
                </v-radio-group>
                <div v-if="hover">
                    <br>
                    <v-divider></v-divider>
                    <v-layout>
                        <v-flex>
                            <v-text-field label="Etiqueta" v-model="d.label" @input="input"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-combobox
                                    v-model="d.opciones"
                                    :items="items"
                                    multiple
                                    chips
                                    label="Ingrese las opciones"
                                    @input="input"
                            ></v-combobox>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card-text>
        </v-card>
    </v-hover>
</template>

<script>
    export default {
        name: "radio",
        props: ['value'],
        data() {
            return {
                d: {
                    label: 'Titulo',
                    opciones: []
                },
                items: [],
                valor: ''
            }
        },
        methods: {
            input() {
                this.$emit('input', this.d);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/formulario/tipos/radio.vue